export default __webpack_public_path__ + "static/media/vinegrafts.164b11e5.jpg";